import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leaving",
  "use": "icon-leaving-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-leaving\"><defs><style type=\"text/css\"></style></defs><path d=\"M737.1 467.8v-90.5h-90.5v90.5h90.5z m-180.9 0v-90.5h-88.3v90.5h88.3z m-178.8 0v-90.5h-90.5v90.5h90.5zM871.7 64c24.4 0 45.2 8.6 62.5 25.8 17.2 17.2 25.8 38.1 25.8 62.5v538.5c0 24.4-8.6 45.6-25.8 63.5-17.2 17.9-38.1 26.9-62.5 26.9H242.8L64 960V152.3c0-24.4 8.6-45.2 25.8-62.5C107 72.6 127.9 64 152.3 64h719.4z\" p-id=\"2041\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leaving.svg
// module id = 9fqe
// module chunks = 77